import React from "react";

export default function Container({
  children,
  fluid = false,
  className = "",
  style = {},
  ...props
}: {
  children: React.ReactNode;
  fluid?: boolean;
  className?: string;
  style?: React.CSSProperties;
  [key: string]: any;
}) {
  return (
    <div
      className={`siteContainer ${className}`}
      style={{
        maxWidth: fluid ? "100%" : undefined,
        ...style,
        ...props,
      }}
    >
      {children}
    </div>
  );
}
